<template>
  <div>
    <v-toolbar flat color="white" class="hidden-sm-and-down">
      <v-toolbar-title>Beklenen Ödeme Kalemleri</v-toolbar-title>
      <v-divider class="mx-3" inset vertical />
      <v-select
        v-model="selectedTenantId"
        :items="tenantOptions"
        item-text="tenantName"
        item-value="tenantId"
        label="Tenant Seç"
        style="min-width: 180px; margin-right: 12px; margin-top: 20px;"
        @change="onTenantChange"
      />
      <v-select
        v-model="selectedMpId"
        :items="marketplaceOptions"
        item-text="mpName"
        item-value="mpId"
        label="Pazaryeri Seç"
        style="min-width: 180px; margin-right: 12px; margin-top: 20px;"
        @change="onMarketplaceChange"
      />
      <v-btn color="primary" dark class="mb-2" @click="openCreateDialog">
        Yeni Ekle
      </v-btn>
      <v-spacer />
      <v-btn icon @click="refresh">
        <v-icon>refresh</v-icon>
      </v-btn>
    </v-toolbar>

    <v-data-table
      :headers="headers"
      :items="tableItems"
      :loading="$store.state.progress"
      :rows-per-page-items="pageItems"
      class="elevation-1"
    >
      <template v-slot:items="props">
        <td class="px-0 text-xs-center">{{ getTransactionTypeName(props.item.transactionType) }}</td>
        <td class="px-0 text-xs-center">{{ getOrderStatusName(props.item.orderStatus) }}</td>
        <td class="px-0 text-xs-center">{{ getCalculationTypeName(props.item.calculationType) }}</td>
        <td class="px-0 text-xs-center">{{ formatValue(props.item) }}</td>
        <td class="px-0 text-xs-center">{{ formatDate(props.item.startDate) }}</td>
        <td class="px-0 text-xs-center">{{ formatDate(props.item.endDate) || 'Sınırsız' }}</td>
        <td class="px-0 text-xs-center">
          <v-icon small class="mr-2" @click="editItem(props.item)" color="primary">edit</v-icon>
          <v-icon small @click="deleteItem(props.item)" color="error">delete</v-icon>
        </td>
      </template>
      <template v-slot:no-data>
        <div class="text-xs-center pa-4">
          <p class="grey--text">Henüz beklenen kalem tanımlanmamış</p>
          <v-btn color="primary" @click="refresh">Yenile</v-btn>
        </div>
      </template>
    </v-data-table>

    <v-dialog v-model="dialog" max-width="600px" persistent>
      <v-card>
        <v-card-title>
          <span class="headline">{{ isEdit ? 'Kalem Düzenle' : 'Yeni Kalem' }}</span>
        </v-card-title>
        <v-card-text>
          <v-form ref="form" v-model="formIsValid">
            <v-select
              v-model="form.tenantId"
              :items="tenantOptions"
              item-text="tenantName"
              item-value="tenantId"
              label="Tenant"
              :rules="[v => !!v || 'Tenant zorunludur']"
            />
            <v-select
              v-model="form.mpId"
              :items="marketplaceOptions"
              item-text="mpName"
              item-value="mpId"
              label="Pazaryeri"
              :rules="[v => !!v || 'Pazaryeri zorunludur']"
            />
            <v-select
              v-model="form.transactionType"
              :items="transactionTypeOptions"
              item-text="text"
              item-value="value"
              label="Ödeme Kalemi Tipi"
              :rules="[v => v !== null && v !== undefined || 'Tip zorunludur']"
            />
            <v-select
              v-model="form.orderStatus"
              :items="orderStatusOptions"
              item-text="text"
              item-value="value"
              label="Sipariş Durumu"
              :rules="[v => v !== null && v !== undefined || 'Durum zorunludur']"
            />
            <v-select
              v-model="form.calculationType"
              :items="calculationTypeOptions"
              item-text="text"
              item-value="value"
              label="Hesaplama Tipi"
              :rules="[v => v !== null && v !== undefined || 'Hesaplama tipi zorunludur']"
              @change="onCalculationTypeChange"
            />
            <v-text-field
              v-if="form.calculationType === 0"
              v-model.number="form.fixedValue"
              label="Sabit Tutar (TL)"
              type="number"
              step="0.01"
              :rules="[
                v => v !== null && v !== undefined || 'Tutar zorunludur'
                //v => v >= 0 || 'Tutar negatif olamaz'
              ]"
            />
            <v-text-field
              v-if="form.calculationType === 1"
              v-model.number="form.percentageValue"
              label="Oran (%)"
              type="number"
              step="0.01"
              :rules="[
                v => v !== null && v !== undefined || 'Oran zorunludur',
                v => v >= -100 && v <= 100 || 'Oran -100-100 arasında olmalıdır'
              ]"
            />
            <v-menu
              v-model="startDateMenu"
              :close-on-content-click="false"
              transition="scale-transition"
              offset-y
              min-width="290px"
            >
              <template v-slot:activator="{ on }">
                <v-text-field
                  v-model="form.startDate"
                  label="Başlangıç Tarihi"
                  prepend-icon="event"
                  readonly
                  v-on="on"
                  :rules="[v => !!v || 'Başlangıç tarihi zorunludur']"
                />
              </template>
              <v-date-picker
                v-model="form.startDate"
                locale="tr-TR"
                @input="startDateMenu = false"
              />
            </v-menu>
            <v-menu
              v-model="endDateMenu"
              :close-on-content-click="false"
              transition="scale-transition"
              offset-y
              min-width="290px"
            >
              <template v-slot:activator="{ on }">
                <v-text-field
                  v-model="form.endDate"
                  label="Bitiş Tarihi (Opsiyonel)"
                  prepend-icon="event"
                  readonly
                  v-on="on"
                  hint="Boş bırakılırsa sınırsız olur"
                  persistent-hint
                />
              </template>
              <v-date-picker
                v-model="form.endDate"
                locale="tr-TR"
                :min="form.startDate"
                @input="endDateMenu = false"
              />
            </v-menu>
            <v-switch
              v-model="form.isActive"
              label="Aktif"
            />
          </v-form>
        </v-card-text>
        <v-card-actions>
          <v-spacer />
          <v-btn text @click="closeDialog">İptal</v-btn>
          <v-btn color="primary" :disabled="!formIsValid" @click="save" :loading="saving">
            Kaydet
          </v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>
  </div>
</template>

<script>
import { mapActions } from 'vuex';
import moment from 'moment';

const DEFAULT_TENANT_OPTIONS = [
  { tenantId: 1, tenantName: 'Altında Fırsat' },
  { tenantId: 2, tenantName: 'E-Altın' },
];

const DEFAULT_MARKETPLACES = [
  { mpId: 1, mpName: 'Hepsiburada' },
  { mpId: 2, mpName: 'Alışgidiş' },
  { mpId: 3, mpName: 'Trendyol' },
  { mpId: 4, mpName: 'Idefix' },
  { mpId: 5, mpName: 'Idia' },
  { mpId: 6, mpName: 'n11' },
];

export default {
  data() {
    return {
      dialog: false,
      isEdit: false,
      saving: false,
      formIsValid: false,
      startDateMenu: false,
      endDateMenu: false,
      selectedTenantId: null,
      selectedMpId: null,
      tenantOptions: DEFAULT_TENANT_OPTIONS,
      marketplaceOptions: DEFAULT_MARKETPLACES,
      form: {
        id: null,
        tenantId: null,
        mpId: null,
        transactionType: null,
        orderStatus: 0,
        calculationType: 0,
        fixedValue: null,
        percentageValue: null,
        startDate: null,
        endDate: null,
        isActive: true
      },
      headers: [
        { text: 'Ödeme Kalemi', value: 'transactionType' },
        { text: 'Sipariş Durumu', value: 'orderStatus' },
        { text: 'Hesaplama Tipi', value: 'calculationType' },
        { text: 'Değer', value: 'value' },
        { text: 'Başlangıç Tarihi', value: 'startDate' },
        { text: 'Bitiş Tarihi', value: 'endDate' },
        { text: 'İşlemler', value: 'actions', sortable: false }
      ],
      transactionTypeOptions: [
        { text: 'Hizmet Bedeli', value: 0 },
        { text: 'Sipariş Tutarı', value: 1 },
        { text: 'MP Stopaj', value: 2 },
        { text: 'Kargo Bedeli', value: 3 },
        { text: 'Komisyon', value: 4 },
        { text: 'İade Tutarı', value: 5 },
        { text: 'Stopaj İade', value: 6 },
        { text: 'Kampanya İndirim', value: 7 },
        { text: 'Komisyon İade', value: 8 },
        { text: 'Altın İşçilik Bedeli Stopaj', value: 9 },
        { text: 'Müşteri Memnuniyeti', value: 10 },
        { text: 'Sevkiyat Maliyeti Paylaşımı Gelir', value: 11 }
      ],
      orderStatusOptions: [
        { text: 'Normal', value: 0 },
        { text: 'İptal', value: 1 },
        { text: 'İade', value: 2 }
      ],
      calculationTypeOptions: [
        { text: 'Sabit Tutar', value: 0 },
        { text: 'Yüzde (Oran)', value: 1 }
      ],
      pageItems: [10, 25, 50, 100, { text: 'Tümü', value: -1 }]
    };
  },
  computed: {
    tableItems() {
      if (!this.$store.state.expectedPayments.items) return [];
      return this.$store.state.expectedPayments.items.filter(item => {
        if (this.selectedTenantId && item.tenantId !== this.selectedTenantId) return false;
        if (this.selectedMpId && item.mpId !== this.selectedMpId) return false;
        return true;
      });
    }
  },
  methods: {
    ...mapActions('expectedPayments', [
      'fetchItems',
      'createItem',
      'updateItem',
      'deleteItem'
    ]),
    formatDate(date) {
      if (!date) return '';
      return moment(date).format('DD.MM.YYYY');
    },
    formatValue(item) {
      if (item.calculationType === 0) {
        return `${item.fixedValue} TL`;
      } else {
        return `%${item.percentageValue}`;
      }
    },
    getTransactionTypeName(value) {
      const option = this.transactionTypeOptions.find(opt => opt.value === value);
      return option ? option.text : '';
    },
    getOrderStatusName(value) {
      const option = this.orderStatusOptions.find(opt => opt.value === value);
      return option ? option.text : '';
    },
    getCalculationTypeName(value) {
      const option = this.calculationTypeOptions.find(opt => opt.value === value);
      return option ? option.text : '';
    },
    onCalculationTypeChange() {
      if (this.form.calculationType === 0) {
        this.form.percentageValue = null;
      } else {
        this.form.fixedValue = null;
      }
    },
    onTenantChange() {
      this.refresh();
    },
    onMarketplaceChange() {
      this.refresh();
    },
    openCreateDialog() {
      this.isEdit = false;
      this.form = {
        id: null,
        tenantId: this.selectedTenantId,
        mpId: this.selectedMpId,
        transactionType: null,
        orderStatus: 0,
        calculationType: 0,
        fixedValue: null,
        percentageValue: null,
        startDate: moment().format('YYYY-MM-DD'),
        endDate: null,
        isActive: true
      };
      this.dialog = true;
    },
    editItem(item) {
      this.isEdit = true;
      this.form = {
        id: item.id,
        tenantId: item.tenantId,
        mpId: item.mpId,
        transactionType: item.transactionType,
        orderStatus: item.orderStatus,
        calculationType: item.calculationType,
        fixedValue: item.fixedValue,
        percentageValue: item.percentageValue,
        startDate: moment(item.startDate).format('YYYY-MM-DD'),
        endDate: item.endDate ? moment(item.endDate).format('YYYY-MM-DD') : null,
        isActive: item.isActive
      };
      this.dialog = true;
    },
    async deleteItem(item) {
      if (!confirm('Silmek istediğinize emin misiniz?')) {
        return;
      }
      try {
        await this.deleteItem({ id: item.id, tenantId: item.tenantId, mpId: item.mpId });
        this.$store.state.dialog = true;
        this.$store.state.message = 'Kalem silindi.';
        await this.refresh();
      } catch (error) {
        this.$store.state.dialog = true;
        const errorMsg = (error.response && error.response.data && error.response.data.message) || error.message;
        this.$store.state.message = 'Silme işlemi sırasında hata oluştu: ' + errorMsg;
      }
    },
    closeDialog() {
      this.dialog = false;
      this.$nextTick(() => {
        if (this.$refs.form) {
          this.$refs.form.resetValidation();
        }
      });
    },
    async save() {
      if (!(await this.$refs.form.validate())) {
        return;
      }
      this.saving = true;
      try {
        const payload = {
          ...this.form,
          startDate: this.form.startDate ? moment(this.form.startDate).toISOString() : null,
          endDate: this.form.endDate ? moment(this.form.endDate).toISOString() : null
        };
        if (this.isEdit && this.form.id) {
          await this.updateItem(payload);
          this.$store.state.dialog = true;
          this.$store.state.message = 'Kalem güncellendi.';
        } else {
          await this.createItem(payload);
          this.$store.state.dialog = true;
          this.$store.state.message = 'Kalem oluşturuldu.';
        }
        this.closeDialog();
        await this.refresh();
      } catch (error) {
        console.error('Kaydetme hatası:', error);
        this.$store.state.dialog = true;
        const errorMsg = (error.response && error.response.data && error.response.data.message) || error.message;
        this.$store.state.message = 'Kaydetme işlemi sırasında hata oluştu: ' + errorMsg;
      } finally {
        this.saving = false;
      }
    },
    async refresh() {
      if (!this.selectedTenantId || !this.selectedMpId) {
        return;
      }
      await this.fetchItems({
        tenantId: this.selectedTenantId,
        mpId: this.selectedMpId
      });
    }
  },
  async mounted() {
    const selectedTenant = localStorage.getItem('selectedTenantId');
    const selectedMp = localStorage.getItem('selectedMpId');
    this.selectedTenantId = selectedTenant ? parseInt(selectedTenant) : null;
    this.selectedMpId = selectedMp ? parseInt(selectedMp) : null;
    await this.refresh();
  }
};
</script>

<style scoped>
</style>

